import qs from 'querystring'
 
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

let url = COOKIECONSTANT.REQUEST_HOST

const getRecommend = () => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?type=13`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.common-banner',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
},
getEnterpriseAccessibility = () => {
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.product.company-area.check',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
},
getEnterpriseBillboards = () => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?type=12`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.common-banner',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0 ) {
        return reject(data.msg)
      }
      resolve(data.data)
    },e => {
      reject(e)
    })
  })
},
getEnterpriseShops = () => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?type=14`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.common-banner',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0 ) {
        return reject(data.msg)
      }
      resolve(data.data)
    },e => {
      reject(e)
    })
  })
}

export default {
  getRecommend,
  getEnterpriseAccessibility,
  getEnterpriseBillboards,
  getEnterpriseShops,
}
